import { colors, Skeleton, Stack } from '@ui-components/neo.tax';
import React from 'react';

export const SideDrawerSkeleton = (): React.ReactElement => (
  <Stack direction="column" overflow="hidden" fullHeight>
    <Stack
      direction="row"
      alignItems="start"
      justifyContent="space-between"
      paddingX={5}
      paddingY={5}
      backgroundColor={colors.primary[600]}
    >
      <Stack direction="column" gap={1}>
        <Skeleton height={6} />
      </Stack>
      <Skeleton height={10} width={10} className="w-10 rounded" />
    </Stack>

    <Stack direction="row" gap={4} paddingX={5} paddingY={3} backgroundColor="bg-white">
      <Skeleton height={8} width={20} className="w-20 rounded" />
      <Skeleton height={8} width={32} className="w-32 rounded" />
      <Skeleton height={8} width={16} className="w-16 rounded" />
      <Skeleton height={8} width={20} className="w-20 rounded" />
    </Stack>

    <Stack direction="column" gap={4} paddingX={5} paddingY={5} fullHeight>
      <Skeleton height={4} width="full" rounded />
      <Skeleton height={4} width="5/6" rounded />
      <Skeleton height={4} width="4/6" rounded />
      <Stack direction="column" gap={2}>
        <Skeleton height={20} width="full" rounded />
        <Skeleton height={20} width="full" rounded />
        <Skeleton height={20} width="full" rounded />
      </Stack>
      <Stack direction="column" gap={4} paddingY={4} fullHeight>
        <Skeleton height={8} width="full" rounded />
        <Skeleton height={8} width="full" rounded />
        <Skeleton height={8} width="full" rounded />
      </Stack>
    </Stack>
  </Stack>
);
